import React from "react";
import {
  ShieldCheck,
  ScanFace,
  LockKeyhole,
  CheckCircle2,
  ArrowRight,
} from "lucide-react";

export default function KycVerification({ onOpenWarning, loading = false }) {
  return (
    <>
      <style>{`
        .kyc-container {
          width: 100%;
          min-height: 430px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px;
          border-radius: 26px;
          text-align: center;
        }

        .kyc-header-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 460px;
  margin: 0 auto 12px;
}

        .kyc-icon-box {
        position: relative;
        top: -5px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2563eb, #06b6d4);
  color: #fff;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.3);
  flex-shrink: 0;
}

        .kyc-title {
          min-width: 0;
  max-width: calc(100% - 60px);
  display: flex;
  align-items: center;
        }

        .kyc-title h2 {
          margin: 0;
          font-size: 28px;
          font-weight: 900;
          color: #0f172a;
          line-height: 1.15;
          text-align: left;
          white-space: normal;
          overflow-wrap: break-word;
          word-break: normal;
        }

        .kyc-description {
          max-width: 430px;
          color: #64748b;
          font-size: 15px;
          line-height: 1.6;
          margin-top: 0px;
          margin-bottom: 20px;
        }

        .kyc-benefits {
          width: 100%;
          max-width: 420px;
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 30px;
        }

        .kyc-benefit {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 14px 18px;
          border-radius: 16px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          color: #334155;
          font-weight: 700;
        }

        .kyc-benefit svg {
          color: #2563eb;
          flex-shrink: 0;
        }

        .kyc-button {
          width: 100%;
          max-width: 360px;
          padding: 16px 24px;
          border: none;
          border-radius: 18px;
          background: linear-gradient(135deg, #2563eb, #06b6d4);
          color: #fff;
          font-size: 16px;
          font-weight: 800;
          cursor: pointer;
          box-shadow: 0 15px 30px rgba(37, 99, 235, 0.25);
          transition: 0.25s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .kyc-button:hover {
          transform: translateY(-3px);
        }

        .kyc-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        @media (max-width: 990px) {
          .kyc-container {
            padding: 0px;
          }

          .kyc-header-row {
            gap: 8px;
            margin-bottom: 15px;
          }

          .kyc-icon-box {
            width: 44px;
            height: 44px;
            margin-top: 2px;
          }

          .kyc-title {
            max-width: calc(100% - 52px);
          }

          .kyc-title h2 {
            font-size: 20px;
            line-height: 1.15;
          }

          .kyc-description {
            max-width: 430px;
            color: #64748b;
            font-size: 15px;
            line-height: 1.6;
            margin-top: 0px;
            margin-bottom: 20px;
          }

          .kyc-benefit span {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="kyc-container">
        <div className="kyc-header-row">
          <div className="kyc-icon-box">
            <ShieldCheck size={32} />
          </div>

          <div className="kyc-title">
            <h2>Verificação de identidade</h2>
          </div>
        </div>

        <p className="kyc-description">
          Para garantir a segurança da plataforma, precisamos confirmar sua
          identidade antes de liberar o pagamento.
        </p>

        <div className="kyc-benefits">
          <div className="kyc-benefit">
            <ScanFace size={25} />
            <span>Reconhecimento facial seguro</span>
          </div>

          <div className="kyc-benefit">
            <LockKeyhole size={22} />
            <span>Seus dados são protegidos</span>
          </div>

          <div className="kyc-benefit">
            <CheckCircle2 size={22} />
            <span>Processo rápido e confiável</span>
          </div>
        </div>

        <button
          className="kyc-button"
          onClick={onOpenWarning}
          disabled={loading}
        >
          {loading ? "Verificando..." : "Verificar"}
          {!loading && <ArrowRight size={20} />}
        </button>
      </div>
    </>
  );
}
